import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgLegalResearch(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M60.219 94.214h44.219v4.044H60.219v-4.044ZM16 94.214h44.219v4.044H16v-4.044Z"
        fill="#78B441"
      />
      <path
        d="M60.219 71.565h44.219v24.536H60.219V71.565ZM16 71.565h44.219v24.536H16V71.565Z"
        fill="#E2E8F0"
      />
      <path
        d="M16 38.94s26.886-9.345 38.827 0c2.345 1.836 5.392 5.393 5.392 5.393v49.88s-3.047-3.556-5.392-5.392c-11.941-9.345-38.827 0-38.827 0V38.94Z"
        fill="#F1F5F9"
      />
      <path
        d="M60.219 44.333s3.047-3.557 5.393-5.393c11.94-9.345 38.826 0 38.826 0v49.881s-26.886-9.345-38.826 0c-2.346 1.836-5.393 5.393-5.393 5.393V44.333Z"
        fill="#F1F5F9"
      />
      <path
        d="M76.633 84.083c4.288-.447 8.838-.148 12.983.442 4.148.59 7.915 1.474 10.643 2.21a85.118 85.118 0 0 1 4.126 1.224l.232.078c.027.01.048.016.062.02l.016.007h.003l.002.002.077.03a.8.8 0 0 1-.523 1.504l-.079-.023-.003-.002-.014-.004-.054-.018-.222-.074a53.07 53.07 0 0 0-.861-.278c-.75-.234-1.837-.56-3.179-.922-2.686-.724-6.386-1.591-10.452-2.17-4.07-.578-8.48-.863-12.59-.434-4.119.43-7.873 1.567-10.695 3.776-1.123.879-2.438 2.19-3.488 3.304a67.163 67.163 0 0 0-1.66 1.828l-.097.113-.026.03-.006.007-.002.001a.8.8 0 1 1-1.214-1.04l.002-.004.007-.008.028-.032.102-.119.383-.433c.326-.367.786-.875 1.32-1.44 1.06-1.125 2.442-2.51 3.664-3.466 3.148-2.464 7.234-3.662 11.515-4.109Z"
        fill="#0F172A"
      />
      <path
        d="M43.805 84.083c-4.288-.447-8.838-.148-12.982.442-4.149.59-7.916 1.474-10.644 2.21a85.272 85.272 0 0 0-4.126 1.224l-.232.078c-.027.01-.048.016-.062.02l-.016.007h-.004l-.002.002-.076.03a.8.8 0 0 0 .523 1.504l.079-.023.003-.002.014-.004.054-.018.222-.074c.196-.065.486-.16.861-.278.75-.234 1.837-.56 3.179-.922 2.686-.724 6.386-1.591 10.452-2.17 4.07-.578 8.48-.863 12.59-.434 4.119.43 7.873 1.567 10.695 3.776 1.123.879 2.438 2.19 3.488 3.304a67.163 67.163 0 0 1 1.66 1.828l.097.113.026.03.006.007.002.001a.8.8 0 1 0 1.214-1.04l-.002-.004-.007-.008-.028-.032-.102-.119-.383-.433a68.473 68.473 0 0 0-1.32-1.44c-1.06-1.125-2.442-2.51-3.664-3.466-3.148-2.464-7.234-3.662-11.515-4.109Z"
        fill="#0F172A"
      />
      <path
        d="M54.827 98.258h10.785a2.157 2.157 0 0 1-2.157 2.157h-6.471a2.157 2.157 0 0 1-2.157-2.157Z"
        fill="#78B441"
      />
      <path d="M59.42 94.248v-49.88a.8.8 0 1 1 1.599 0v49.88a.8.8 0 1 1-1.6 0Z" fill="#0F172A" />
      <path
        d="M36.418 42.618c5.617-.102 11.723.731 16.48 3.647a.8.8 0 1 1-.836 1.364c-4.38-2.685-10.128-3.511-15.615-3.41-5.472.099-10.577 1.118-13.585 2.02a.8.8 0 0 1-.459-1.533c3.134-.94 8.384-1.985 14.015-2.088ZM36.418 50.945c5.617-.102 11.723.73 16.48 3.647a.8.8 0 1 1-.836 1.364c-4.38-2.685-10.128-3.511-15.615-3.411-5.472.1-10.577 1.12-13.585 2.021a.8.8 0 0 1-.459-1.533c3.134-.94 8.384-1.985 14.015-2.088ZM36.418 59.052c5.617-.102 11.723.73 16.48 3.647a.8.8 0 1 1-.836 1.364c-4.38-2.685-10.128-3.511-15.615-3.411-5.472.1-10.577 1.119-13.585 2.021a.8.8 0 0 1-.459-1.533c3.134-.94 8.384-1.985 14.015-2.088ZM36.418 67.159c5.617-.103 11.723.73 16.48 3.646a.8.8 0 1 1-.836 1.365c-4.38-2.685-10.128-3.511-15.615-3.411-5.472.1-10.577 1.119-13.585 2.021a.8.8 0 0 1-.459-1.533c3.134-.94 8.384-1.985 14.015-2.088ZM36.418 75.266c5.617-.103 11.723.73 16.48 3.646a.8.8 0 1 1-.836 1.365c-4.38-2.686-10.128-3.512-15.615-3.412-5.472.1-10.577 1.12-13.585 2.022a.8.8 0 0 1-.459-1.533c3.134-.94 8.384-1.985 14.015-2.088ZM83.652 42.618c-5.618-.102-11.723.731-16.48 3.647a.8.8 0 1 0 .835 1.364c4.381-2.685 10.129-3.511 15.615-3.41 5.473.099 10.578 1.118 13.585 2.02a.8.8 0 0 0 .46-1.533c-3.135-.94-8.384-1.985-14.015-2.088ZM83.651 50.945c-5.617-.102-11.722.73-16.48 3.647a.8.8 0 1 0 .836 1.364c4.38-2.685 10.129-3.511 15.615-3.411 5.472.1 10.578 1.12 13.585 2.021a.8.8 0 0 0 .46-1.533c-3.135-.94-8.384-1.985-14.016-2.088ZM83.651 59.052c-5.617-.102-11.722.73-16.48 3.647a.8.8 0 1 0 .836 1.364c4.38-2.685 10.129-3.511 15.615-3.411 5.472.1 10.578 1.119 13.585 2.021a.8.8 0 0 0 .46-1.533c-3.135-.94-8.384-1.985-14.016-2.088ZM83.651 67.159c-5.617-.103-11.722.73-16.48 3.646a.8.8 0 1 0 .836 1.365c4.38-2.685 10.129-3.511 15.615-3.411 5.472.1 10.578 1.119 13.585 2.021a.8.8 0 0 0 .46-1.533c-3.135-.94-8.384-1.985-14.016-2.088ZM83.651 75.266c-5.617-.103-11.722.73-16.48 3.646a.8.8 0 1 0 .836 1.365c4.38-2.686 10.129-3.512 15.615-3.412 5.472.1 10.578 1.12 13.585 2.022a.8.8 0 0 0 .46-1.533c-3.135-.94-8.384-1.985-14.016-2.088Z"
        fill="#B3C0D0"
      />
      <path
        d="m77.046 51.41 25.379 21.16a5.598 5.598 0 1 1-7.5 8.299l-23.608-23.12 5.73-6.338Z"
        fill="#007A5F"
      />
      <path d="m85.023 58.061.752 13.849-14.458-14.161 5.73-6.338 7.976 6.65Z" fill="#00664F" />
      <path
        d="m85.023 58.061.752 13.849-14.458-14.161 5.73-6.338 7.976 6.65Zm-11.49-.38 10.422 10.206-.492-9.044-6.261-5.22-3.668 4.058Z"
        fill="#00664F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.228 64.553c11.456 5.865 25.497 1.333 31.362-10.123 5.865-11.454 1.333-25.496-10.123-31.361-11.455-5.865-25.496-1.333-31.361 10.122-5.865 11.456-1.333 25.497 10.122 31.362Z"
        fill="#78B441"
      />
      <path
        d="M79.932 44.194c0 9.224-7.477 16.7-16.7 16.7-9.224 0-16.7-7.476-16.7-16.7 0-9.223 7.476-16.7 16.7-16.7 9.223 0 16.7 7.477 16.7 16.7Z"
        fill="#E6F4F0"
      />
      <path
        d="M49.615 44.194c0-7.52 6.096-13.616 13.616-13.616a.8.8 0 1 1 0 1.6c-6.636 0-12.016 5.38-12.016 12.016a.8.8 0 1 1-1.6 0Z"
        fill="#fff"
      />
      <path
        d="M45.732 44.194c0-9.665 7.835-17.5 17.5-17.5a.8.8 0 1 1 0 1.6c-8.782 0-15.9 7.119-15.9 15.9 0 8.782 7.118 15.9 15.9 15.9a.8.8 0 1 1 0 1.6c-9.665 0-17.5-7.834-17.5-17.5ZM91.056 17.353a.8.8 0 0 1 1.054 1.205l-6.215 5.436a.8.8 0 1 1-1.052-1.204l6.213-5.437ZM92.106 27.294a.8.8 0 0 1 .506 1.518l-4.66 1.554a.8.8 0 0 1-.506-1.518l4.66-1.554ZM80.8 15.214a.8.8 0 0 1 1.371.822l-2.33 3.884a.8.8 0 1 1-1.372-.822l2.33-3.884Z"
        fill="#0F172A"
      />
    </svg>
  )
}
export default wrapIllustration(SvgLegalResearch)
